import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { TagModule } from 'primeng/tag';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { BasicAction } from 'src/app/core-module/models/Audits/AuditResults/basic-action';

@Component({
  selector: 'app-action-children',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule, PaginatorModule, TagModule, ToggleSwitchModule],
  templateUrl: './action-children.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './action-children.component.scss'
})
export class ActionChildrenComponent implements OnChanges {
  @Input() childActions: BasicAction[] = [];
  @Output() createChild = new EventEmitter<void>();
  @Output() openChild = new EventEmitter<number>();

  showResolved: boolean = false;
  pageSize: number = 5;
  pageIndex: number = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['childActions']) {
      this.pageIndex = 0;
    }
  }

  create(){
    this.createChild.emit();
  }

  open(id:number){
    this.openChild.emit(id);
  }

  get pagedChildActions(): BasicAction[] {
    const start = this.pageIndex * this.pageSize;
    return this.filteredChildActions.slice(start, start + this.pageSize);
  }

  get filteredChildActions(): BasicAction[] {
    return this.showResolved ? this.childActions : this.childActions.filter(c => !c.Resolved);
  }

  onPageChange(event:any){
    this.pageIndex = event.page ?? 0;
    this.pageSize = event.rows ?? this.pageSize;
  }

  onResolvedToggle(value: boolean){
    this.showResolved = value;
    this.pageIndex = 0;
  }
}
